










































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import store from '@/store'

@Component({})
export default class Users extends Vue {
  private publicPath: string = process.env.BASE_URL
  private selectItems: any[] = [
    'user_id',
    'username',
    'nickname',
    'email',
    'created_at'
  ]
  private filterKey: string = ''
  private filterValue: string = ''
  private pageNum: number = 20
  private pageSum: number = 0
  private pageIndex: number = 1
  private countStart: number = 0
  private countEnd: number = 0
  private total: number = 0
  private lastPageDisabled: boolean = true
  private nextPageDisabled: boolean = true
  private users: any[] = []
  private dialogUser: boolean = false
  private dialogUserTitle: string = 'Add User'
  private dialog: boolean = false
  private userInfo: any = {}
  private file: any = null
  private nameError: boolean = false
  private nameErrorsMsg: string = ''
  private emailError: boolean = false
  private emailErrorsMsg: string = ''
  private oldInfo: any = {}
  private showPassword: boolean = false
  private emailRules: any = [
    (v: any) => !!v || 'Email is required',
    (v: any) => /.+@.+\..+/.test(v) || 'Email format is invalid'
  ]
  private valid: boolean = false
  private nameRules: any = [(v: any) => !!v || 'Username is required']
  private nicknameRules: any = [(v: any) => !!v || 'Nickname is required']
  private passwordRules: any = [
    (v: any) => !!v || 'Password is required',
    (v: any) => (v && v.length >= 8) || 'Min 8 characters',
    (v: any) =>
      /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(v) ||
      'The password must contain at least one letter and one number'
  ]
  private btnDisabled: boolean = false
  private btnLoading: boolean = false

  private created() {
    if (this.publicPath === '/') {
      this.publicPath = ''
    } else {
      this.publicPath = '/vue-vuetify-admin'
    }
  }

  private mounted() {
    this.getUsers()
  }

  private checkUsername(name: string) {
    if (name) {
      this.axios({
        url: '/api/v1/get/username/' + name,
        method: 'GET'
      }).then((res: any) => {
        if (res.data.status) {
          this.nameError = false
          this.nameErrorsMsg = ''
        } else {
          this.nameError = true
          this.nameErrorsMsg = 'Username already exists'
        }
      })
    }
  }
  private checkEmail(email: string) {
    if (email !== '' && email !== this.oldInfo.email) {
      this.axios({
        url: '/api/v1/get/email/' + email,
        method: 'GET'
      }).then((res: any) => {
        if (res.data.status) {
          this.emailError = false
          this.emailErrorsMsg = ''
        } else {
          this.emailError = true
          this.emailErrorsMsg = 'Email already exists'
        }
      })
    }
  }

  private formValidate() {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      return true
    } else {
      return false
    }
  }
  private async submit() {
    if (this.formValidate() && !this.nameError && !this.emailError) {
      this.btnDisabled = true
      this.btnLoading = true
      const info = JSON.parse(JSON.stringify(this.userInfo))
      console.info('this.userInfo: ', this.userInfo)
      if (this.file) {
        const res = await this.uploadFile()
        if (res) {
          info.avatar = res
        }
      } else {
        info.avatar = '/img/avatar.png'
      }
      console.info('info submit: ', info)
      if (this.dialogUserTitle === 'Add User') {
        // add user
        this.axios({
          url: '/api/v1/users',
          method: 'POST',
          data: info
        }).then((res: any) => {
          if (res.data.status) {
            console.info('success')
            this.btnDisabled = false
            this.btnLoading = false
            this.dialogUser = false
            store.dispatch('updateShowAlert', {
              showAlert: true,
              alertMessage: 'add user success',
              alertType: 'success'
            })
            this.getUsers()
          } else {
            store.dispatch('updateShowAlert', {
              showAlert: true,
              alertMessage: 'add user error',
              alertType: 'error'
            })
          }
        })
      } else {
        // edit user
        this.axios({
          url: '/api/v1/users',
          method: 'PUT',
          data: {
            user_id: this.userInfo.user_id,
            user_info: info
          }
        }).then((res: any) => {
          if (res.data.status) {
            this.btnDisabled = false
            this.btnLoading = false
            this.dialogUser = false
            store.dispatch('updateShowAlert', {
              showAlert: true,
              alertMessage: 'add user success',
              alertType: 'success'
            })
            this.getUsers()
          } else {
            console.info('error')
            store.dispatch('updateShowAlert', {
              showAlert: true,
              alertMessage: 'edit user error',
              alertType: 'error'
            })
          }
        })
      }
    } else {
      console.error('validate false') // tslint:disable-line
    }
  }

  private async uploadFile() {
    // get upload url
    const fileName = this.file.name
    const ficonstype = this.file.type.split('/')[1]
    const result: any = await this.axios({
      url: '/api/v1/get_upload_url',
      data: {
        filename: fileName,
        upload_method: 'post'
      },
      method: 'get'
    }).then((res: any) => {
      return res
    })

    // post upload file
    const formData = new FormData()
    formData.append('file', this.file)
    console.info(result.data.data.url)
    await fetch(result.data.data.url, {
      method: 'POST',
      body: formData
    })
      .then((res: any) => {
        return res
      })
      .catch((err: any) => {
        // console.error('err: ', err)
        return err
      })

    return result.data.data.file_address
  }

  private formReset() {
    (this.$refs.form as Vue & { reset(): () => void }).reset()
  }

  private fileChange() {
    if ((this.$refs.fileInput as Vue & { files: () => any }).files.length > 0) {
      const fs: any = (this.$refs.fileInput as Vue & { files: () => any }).files
      this.file = fs[0]
      const reader = new FileReader()
      const self = this
      reader.readAsDataURL(this.file)
      reader.onload = (e: any) => {
        const dataBase64: any = reader.result
        self.userInfo.avatar = dataBase64
      }
    }
  }

  private changeFile() {
    (this.$refs.fileInput as Vue & { click: () => void }).click()
  }

  private getUsers() {
    const filter: object = {
      pageIndex: this.pageIndex,
      pageNum: this.pageNum,
      filterKey: this.filterKey,
      filterValue: this.filterValue
    }
    this.axios
      .get('/api/v1/users', {
        params: filter
      })
      .then((res: any) => {
        if (res && res.data.status && res.data.data.users.length > 0) {
          const data: any = res.data.data
          this.users = data.users
          this.pageSum = data.page_sum
          this.pageIndex = data.page_index
          this.total = data.total

          if (this.pageIndex === data.page_sum) {
            this.nextPageDisabled = true
          } else {
            if (data.page_sum > 1) {
              this.nextPageDisabled = false
            }
          }

          if (this.pageIndex === 1) {
            this.countStart = 1
            this.countEnd = 0 + this.users.length
          } else {
            this.countStart = (this.pageIndex - 1) * this.pageNum + 1
            this.countEnd = this.countStart + this.users.length - 1
          }
        } else {
          this.users = []
          this.pageSum = 0
          this.pageIndex = 0
          this.total = 0
        }
      })
  }

  private addUser() {
    this.dialogUserTitle = 'Add User'
    this.dialogUser = true
    this.userInfo = {}
    setTimeout(() => {
      this.formReset()
    }, 50)
  }

  private enter() {
    this.pageIndex = 1
    this.getUsers()
  }

  private lastPage() {
    console.info('lastPage')
    this.pageIndex--
    if (this.pageIndex === 1) {
      this.lastPageDisabled = true
    }
    this.getUsers()
  }

  private nextPage() {
    console.info('nextPage')
    this.pageIndex++
    if (this.pageIndex === this.pageSum) {
      this.nextPageDisabled = true
    }
    this.lastPageDisabled = false
    this.getUsers()
  }

  private closeDialogUser() {
    console.info('closeDialogUser')
    this.dialogUser = false
  }

  private deconsteClick(item: object) {
    this.dialog = true
    this.userInfo = item
    console.info(item)
  }

  private deconsteUser() {
    console.info('deconsteUser')
    const userId: number = this.userInfo.user_id
    this.axios({
      url: '/api/v1/users/' + userId,
      method: 'DELETE'
    }).then((res: any) => {
      if (res.status) {
        console.info('deconste user success, id: ' + userId)
        this.dialog = false
        this.getUsers()
      } else {
        // console.error('deconste user error') // tslint:disable-line
      }
    })
  }

  private editUser(val: any) {
    console.info('eidtUser')
    console.info(val)
    console.info('i')
    this.userInfo = val
    this.dialogUserTitle = 'Edit User'
    this.dialogUser = true
  }
}
